import { RenderUnsettledUI } from 'shared/components/render-unsettled-ui/render-unsettled-ui';
import { IssueDocumentDataProvider } from './issue-document-form/issue-document-form-provider/issue-document-form-data-provider';
import { useGetDocumentModels } from '../commons/hooks/use-get-document-models/use-get-document-models';

export const IssueDocument = () => {
  const documentModelsQuery = useGetDocumentModels();

  if (documentModelsQuery.status !== 'success') {
    return <RenderUnsettledUI data={documentModelsQuery} />;
  }

  return <IssueDocumentDataProvider documentModelsResponse={documentModelsQuery.data} />;
};
